import React, { useEffect, useState } from "react";
import { Box, Button, Flex, Grid, GridItem, Spacer, Text } from "@chakra-ui/react";
import { Header, Title } from "../../Components";
import { UserDetails } from "./UserDetails";
// import { Footer } from "../../Components/Footer";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector, useDeviceType } from "app/hooks";
import basePlanImage from "Assets/base-plan-image.png";
import superTopUpPlanImage from "Assets/Super-top-up-image.svg";

import { capitalizeFirstLetter } from "Services/general";
import { useToastService } from "app/hooks/useToastService";
import { config } from "config";

// import { Modal } from "Core/Modal";


export const Home = () => {
  // const { proposer, authToken } = useAppSelector((state) => state.members);
  // const { showErrorToast } = useToastService();
  // useEffect(() => {
  //   if (!authToken) {
  //     showErrorToast({
  //       title:
  //         "Unauthorised access. Please restart your journey from " + config.clientlink,
  //     });
  //     return;
  //   }
  // }, []);
  return (
    <>
      <Header isHome />
      <Box className="mx-auto max-w-[750px]">
        <Box className="px-4">
          {/* <UserDetails /> */}
          <Box mt='8'>
            <Text mt='2' fontSize={'lg'} fontWeight={'bold'}>Enrolment window of IITRAA Super top up plan has ended. Thank you for showing your interest</Text>
          </Box>
        </Box>
      </Box>
    </>
  );
};
